<template>
  <div>
    <tag-manager resourceType="record" :resource='record' :organization-id="record.organization_id" @reload-list="success" />

    <div class="tag-dropdown-column">
      <div class="existing-tags-wrapper" :class="tag.color" v-for="tag in record.tags">
        <div class="btn-group btn-group-toggle" data-toggle="buttons">
          <label class="btn active">
              {{tag.name}}
          </label>

          <label class="btn" @click.prevent="removeConnectedTag(tag)">
            <i class="fa fa-remove"></i>
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import _tags_manager from "./_tags_manager"

  export default {
    components: {
      'tag-manager': _tags_manager
    },
    props: ['record', 'sharedFolder'],
    methods: {
      success() {
        this.$emit('success')
      },
      removeConnectedTag(tag) {
        let params = {
          record_id: this.$props.record.id,
          organization_id: this.sharedFolder.organization_id }
        this.store.removeSharedConnectedTag(tag.id, params).then(() => {
          this.store.sendMetrics({name: 'remove_tag_shared_from_file', params: this.$route.params, path: this.$route.fullPath})
          this.success()
        })
      },
    }
  }
</script>
